import {
  SxProps,
  Table as MuiTable,
  TableProps as MuiTableProps,
} from "@mui/material";

interface TableProps extends MuiTableProps {
  borderless?: boolean;
  sx?: SxProps;
}

const Table = ({
  borderless = false,
  children,
  sx,
  ...tableProps
}: TableProps) => (
  <MuiTable
    {...tableProps}
    sx={{
      border: (theme) =>
        borderless ? "none" : `1px solid ${theme.palette.shades.neutral[100]}`,
      borderRadius: "8px",
      borderCollapse: "unset",
      overflow: "hidden",
      ...sx,
    }}
  >
    {children}
  </MuiTable>
);

export default Table;
